import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { LegendItem, ChartType } from '../lbd/lbd-chart/lbd-chart.component';
import * as Chartist from 'chartist';
import { environment } from 'environments/environment';
import { UtilserviceService } from 'app/services/utilservice.service';
import { AttemptHistory, DashboardDetails, JWTUser, SubjectsModel } from 'Model';
import { ToastrService } from 'ngx-toastr';
import { AttemptService } from 'app/services/attempt.service';
import { DashboardService } from 'app/services/dashboard.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {

  public hoursChartType: ChartType;
  public hoursChartData: any;
  public hoursChartOptions: any;
  public hoursChartResponsive: any[];
  public hoursChartLegendItems: LegendItem[];
  style: any;
  subjects = [];
  user: JWTUser;
  attemptWindow: Window;
  dasboardDetails: DashboardDetails = {
    credits: 0,
    creditExpiryDate: undefined,
    name: '',
    attempts: [],
    totalAttempts: 0
  };
  creditActive: boolean = false;
  showCreditsBadge: boolean = false;
  btnClicked = false;
  creditText: any;
  message: string;
  loading = false;
  previousAttempt: AttemptHistory;
  paymentRedirectUrl: string;
  private visibilityChangeListener: EventListener;

  constructor(private util: UtilserviceService, private attemptServices: AttemptService, private toastr: ToastrService, private dashboardServices: DashboardService,
    public cdr: ChangeDetectorRef ) { }
  ngOnDestroy(): void {
    if (this.visibilityChangeListener) {
      document.removeEventListener('visibilitychange', this.visibilityChangeListener);
    }
  }
  async ngOnInit() {
    this.style = this.util.getDomainEnviroment().style;
    this.user = JSON.parse(this.util.getCurrentUser());
    this.dasboardDetails.name = this.user.name;

    this.getDashboardDetails();
    this.visibilityChangeListener = async () => {
      if (!document.hidden) {
        // Reload the page data when the user switches back to the tab
        this.getDashboardDetails();
      }
    };
    document.addEventListener('visibilitychange', this.visibilityChangeListener);
  }

  async getDashboardDetails() {
    try{
      this.loading = true;
      this.dashboardServices.getDashboardDetails(this.user.email).then((d: any) => {
        this.dasboardDetails = d;
        this.showCreditsBadge = this.dasboardDetails.credits != 0;
        this.creditText = this.dasboardDetails.credits == -1 ? 'Unlimited' : this.dasboardDetails.credits;
        this.creditActive = new Date(this.dasboardDetails.creditExpiryDate) > new Date();
        this.performanceGraph();
      }).catch((e) => {
        console.log(e);
      }).finally(() => this.loading = false);
    }
    catch (e){
      this.toastr.warning("An error has occured");
      console.log(`error: ${e}`);
      
    }  

  }
  performanceGraph() {
    let scoresDict = new Map<string, Array<number>>();
    this.dasboardDetails.attempts.forEach(a => {
      this.createScoreDictValue(a, scoresDict);
    });
    this.loadDashBoardStats(scoresDict);
  }

  createScoreDictValue(history: AttemptHistory, scoreDict: Map<string, number[]>) {
    history.subjectsScores.forEach(e => {
      let subject = e.subject;
      let score = e.score as number;
      if (!scoreDict.has(subject))
        scoreDict.set(subject, []);
      scoreDict.get(subject)?.push(score);
    });
  }

  async takeAttempt() {
    try {     
      let user = JSON.parse(this.util.getCurrentUser()) as JWTUser;
      let data = {
        "Email": user.email,
        "Domain": user.domain
      }
      this.btnClicked = true;
      let result = await this.attemptServices.takeAttempt(data);
      this.openAttemptWindow(result.url);
    } catch (e) {

    } finally {
      this.btnClicked = false;
    }
  }
  
  openAttemptWindow(url) {
    this.closeAttemptWindow();
    this.attemptWindow = window.open(`/external?url=${url}`);
    let checkWindowClosedInterval = setInterval(() => {     
      if (this.attemptWindow == null) {
        this.paymentRedirectUrl = encodeURI(url);
        this.cdr.detectChanges();
      }
      else{        
        this.paymentRedirectUrl = '';
        this.cdr.detectChanges();
        clearInterval(checkWindowClosedInterval);
      }
    }, 500);
  }
  closeAttemptWindow() {
    if (this.attemptWindow) {
      this.attemptWindow.close();
    }
    this.attemptWindow = null;
  }

  loadDashBoardStats(score: Map<string, Array<number>>) {
    let scorearr = [];
    let higherlimit = 0;

    score.forEach((val, key) => {
      const maxValue = Math.max(...val);
      higherlimit = Math.max(higherlimit, maxValue);
      scorearr.push({ name: key, data: val });
    });

    this.previousAttempt = this.dasboardDetails.attempts.slice(-1)[0];
    if (this.previousAttempt) {
      this.subjects = this.previousAttempt.subjectsScores.map(e => ({
        sub: e.subject,
        score: e.score,
        percentagescore: e.percentagescore ?? 0
      }));
    }

    this.hoursChartType = ChartType.Line;
    this.hoursChartData = {
      labels: [1, 2, 3, 4, 5],
      series: scorearr
    };
    this.hoursChartOptions = {
      fullWidth: true,
      low: 0,
      high: this.dasboardDetails.attempts.length > 0 ? higherlimit : 100,
      showArea: false,
      //height: '245px',
      axisX: {
        showGrid: true,
      },
      axisY: {
        onlyInteger: true,
      },
      lineSmooth: [Chartist.Interpolation.cardinal({
        tension: 0.8,
      }), Chartist.Interpolation.simple({
        divisor: 20
      })],
      showLine: true,
      showPoint: true,

    };
    this.hoursChartResponsive = [
      ['screen and (max-width: 640px)', {
        axisX: {
          labelInterpolationFnc: function (value) {
            return value[0];
          }
        }
      }]
    ];
    let legends = [];
    let alphabet = 'a';
    setTimeout(() => {
      scorearr.forEach(e => {
        let color = this.getLegendColors('ct-series-' + alphabet);
        legends.push({
          title: e.name,
          imageClass: `background-color: ` + color
        })
        alphabet = this.increaseAlphabetically(alphabet);
      });
      this.hoursChartLegendItems = legends;
    }, 2);
    this.message = this.dasboardDetails.attempts.length > 0 ? '' : "You have no attempt record yet. <a href='/upgrade'>Buy Credits</a> to take a test"
  }

  getLegendColors(className: string) {
    const parentElement = document.getElementsByClassName(className)[0];
    if (parentElement == null) {
      setTimeout(() => {
        this.getLegendColors(className);
      }, 1);
    }
    else {
      const path = parentElement.getElementsByClassName('ct-point')[0];
      const styles = window.getComputedStyle(path).stroke;
      return styles;
    }
  }
  increaseAlphabetically(char: string): string {
    const charCode = char.charCodeAt(0);
    if (charCode < 65 || charCode > 122 || (charCode > 90 && charCode < 97)) {
      return char;
    }
    let nextCharCode = charCode + 1;
    if ((charCode <= 90 && nextCharCode > 90) || nextCharCode > 122) {
      nextCharCode = 65;
    }
    return String.fromCharCode(nextCharCode);
  }
}
